import _ from 'underscore';
import { Status } from '@bingads-webui-campaign-react/diagnostic-card';
import { isSDK } from '@bingads-webui-campaign-react/sdk-utils';
import { getRoutePathById, allSiteMap } from '@bingads-webui-react/with-site-map';

import { statusAndActionReport, auditPointDisplayed, getFullProductUrl } from './utils';
import { DetailCardsKey } from '../const';

const STATUS_TEXT = {
  NoIssue: _TL_('No issue'),
  InappropriateTarget: _TL_('Inappropriate target'),
};

export const getBiddingStatus = ({
  details, scope, i18n, activity, locale,
}) => {
  if (_.isEmpty(details)
    || _.isEmpty(_.get(details, 'Value'))
    || _.get(details, ['Value', 'ErrorCode'], 0) !== 0
    || _.get(details, ['Value', 'ErrorMessage'])) {
    statusAndActionReport({
      activity,
      type: 'bidding',
      details: `Error - details: ${JSON.stringify(details)}`,
    });
    return {
      name: i18n.getString(_TL_('Bid strategy')),
      key: DetailCardsKey.bidding,
    };
  }

  const status = _.get(details, ['Value', 'Status']);
  const auditPoint = _.get(details, ['Value', 'AuditPoints', 0]);

  if (!['AutoBiddingLimitedUnAttainableTarget', 'BiddingStatusNormal'].includes(auditPoint)) {
    activity.error(`Audit point mapping not found in getBiddingStatus:${auditPoint}`);
  }

  auditPointDisplayed({ activity, auditPoint, area: 'Bidding' });

  const cardDetails = auditPoint === 'AutoBiddingLimitedUnAttainableTarget' ? {
    statusLabelMsg: i18n.getString(_TL_('Limited by auto-bidding target')),
    cardTitle: i18n.getString(_TL_('Set an appropriate target for your bid strategy')),
    cardMsg: i18n.getString(_TL_('Your campaign\'s performance is limited by your bid\'s target . You\'ll improve your conversion rate by decreasing the target ROAS or increasing the target CPA.')),
    onCardButtonClicked: () => {
      statusAndActionReport({
        activity,
        type: 'bidding',
        action: 'navigate to settings page',
        details: `AuditPoint: ${auditPoint}`,
      });

      if (!isSDK()) {
        scope.save(getRoutePathById(allSiteMap, 'settings'));
      } else {
        const url = getRoutePathById(allSiteMap, 'sdk-budget-settings');
        scope.save(url);
      }
    },
    cardButtonText: i18n.getString(_TL_('Fix now')),
    learnMoreLink: `https://help.ads.microsoft.com/#apex/ads/${locale}/56786/1`,
  } : {};

  return {
    name: i18n.getString(_TL_('Bid strategy')),
    key: DetailCardsKey.bidding,

    status: status === 'NoIssue' ? Status.Active : Status.Error,
    statusLabelMsg: i18n.getString(_.get(STATUS_TEXT, status, _TL_(''))),

    ...cardDetails,
  };
};
